<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs tabs-auto" v-model="tabsActive">
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setColor="setColor"
                      @resetColor="resetColor"
                      :setRed="exibirCadastrosVermelhos"
                      :setGreen="exibirCadastrosVerdes"
                    ></Subtitle>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="familias-visitadas"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loading"
                  :ultimaAtualizacaoSincronizadorC="
                    ultimaAtualizacaoSincronizadorC
                  "
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab title="Resultado">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-md-12">
              <div class="box">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-listine-dots"></i> Famílias visitadas
                  </h4>
                </div>
                <div class="box-body">
                  <table
                    class="table table-responsive table-bordered text-center table2"
                    id="table"
                  >
                    <thead>
                      <tr>
                        <th>Por</th>
                        <th>Total</th>
                        <th>
                          A visitar / Dia
                          <span
                            v-b-tooltip.hover
                            title="Estimativa para visitar todas as famílias em 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Menos de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Famílias visitadas no últimos 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Mais de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Famílias visitadas há mais de 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Município</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="dadosResultadoMunicipio.denominador"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                dadosResultadoMunicipio.denominador / 21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${dadosResultadoMunicipio.numerador}
                                (${dadosResultadoMunicipio.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${
                                  dadosResultadoMunicipio.denominador -
                                  dadosResultadoMunicipio.numerador
                                }

                                (${100 - dadosResultadoMunicipio.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr v-if="equipe != ''">
                        <td>Equipe</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="dadosResultadoEquipe.denominador"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(dadosResultadoEquipe.denominador / 21)
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${dadosResultadoEquipe.numerador}
                                (${dadosResultadoEquipe.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${
                                  dadosResultadoEquipe.denominador -
                                  dadosResultadoEquipe.numerador
                                }

                                (${100 - dadosResultadoEquipe.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr v-if="micro_area != ''">
                        <td>Microárea {{ micro_area }}</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="dadosResultadoMicroArea.denominador"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                dadosResultadoMicroArea.denominador / 21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${dadosResultadoMicroArea.numerador}
                                (${dadosResultadoMicroArea.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${
                                  dadosResultadoMicroArea.denominador -
                                  dadosResultadoMicroArea.numerador
                                }

                                (${100 - dadosResultadoMicroArea.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <FonteSincronizadorC />
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions.js'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'FamiliasVisitadas',
  components: {
    PulseLoader,
    Loader,
    Subtitle,
    SelectsV2,
    TabelaCadastros,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      tabsActive: 0,
      equipe: '',
      micro_area: '',
      cadastrosOriginais: [],
      cadastros: [],
      dadosResultadoMunicipio: {
        denominador: 0,
        numerador: 0,
        resultado: 0,
      },
      dadosResultadoEquipe: {
        denominador: 0,
        numerador: 0,
        resultado: 0,
      },
      dadosResultadoMicroArea: {
        denominador: 0,
        numerador: 0,
        resultado: 0,
      },
      loading: false,
      dadosDoResultado: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      setColor: null,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ultimaAtualizacaoSincronizadorC() {
      if (this.$store.getters['getSincronizadorC'] !== null) {
        return this.$store.getters['getSincronizadorC'].ultimaAtualizacao
          .split('/')
          .reverse()
          .join('-')
      }
      return null
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(
          data,
          this.ultimaAtualizacaoSincronizadorC
        )
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(
          data,
          this.ultimaAtualizacaoSincronizadorC
        )
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },
    resetColor() {
      this.setColor = false
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
    },
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = false
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.tabsActive = 0
        this.equipe = event
        this.cadastros = []
        await this.buscarCadastrosPorEquipe()
        this.setarPercentualEquipe()
      } else {
        this.tabsActive = 0
        this.equipe = ''
        this.cadastros = []
        this.cadastrosOriginais = []
      }
    },

    async buscarCadastrosPorEquipe() {
      try {
        this.loading = true
        const response = await this.$api.get(
          `/app/familias-visitadas/${this.$store.state.cod_ibge}/equipe/${this.equipe.ine_esf_eap}`
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.filtros(
            this.exibirCadastrosVermelhos,
            this.exibirCadastrosVerdes
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      if (event !== null) {
        this.micro_area = event.micro_area
        await this.buscarCadastrosMicroArea()
        this.setarPercentualMicroArea()
      } else {
        this.cadastrosMapa = []
        this.cadastrosOriginais = []
        this.cadastros = []
        this.micro_area = ''
        await this.onChangeEquipe(this.equipe)
      }
    },

    async buscarCadastrosMicroArea() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/familias-visitadas/' +
            this.$store.state.cod_ibge +
            '/equipe/' +
            this.equipe.ine_esf_eap +
            '/microarea/' +
            this.micro_area
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.filtros(
            this.exibirCadastrosVermelhos,
            this.exibirCadastrosVerdes
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    setarPercentualMunicipio() {
      let res = Functions.percentualMunicipio(this.dadosDoResultado)
      this.dadosResultadoMunicipio.denominador = res.denominador
      this.dadosResultadoMunicipio.resultado = res.resultado
      this.dadosResultadoMunicipio.numerador = res.numerador
    },

    setarPercentualEquipe() {
      let res = Functions.percentualEquipe(
        this.dadosDoResultado,
        this.equipe.ine_esf_eap
      )
      this.dadosResultadoEquipe.denominador = res.denominador
      this.dadosResultadoEquipe.resultado = res.resultado
      this.dadosResultadoEquipe.numerador = res.numerador
    },

    setarPercentualMicroArea() {
      let res = Functions.percentualMicroArea(
        this.dadosDoResultado,
        this.equipe.ine_esf_eap,
        this.micro_area
      )
      this.dadosResultadoMicroArea.denominador = res.denominador
      this.dadosResultadoMicroArea.resultado = res.resultado
      this.dadosResultadoMicroArea.numerador = res.numerador
    },

    async init() {
      try {
        this.loading = true
        let response = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[21]`
        )
        if (response) {
          this.dadosDoResultado = response.data
          // dados do município
          this.setarPercentualMunicipio()

          // Enfermeiro, médico ...
          if (this.enableSelect == 2) {
            let equipe = this.$store.state.equipesV2.find((el) => {
              return el.ine_esf_eap == this.$store.state.nu_ine
            })
            if (equipe) {
              this.equipe = {
                ine_esf_eap: equipe.ine_esf_eap,
                no_equipe: equipe.no_esf_eap,
              }
              this.buscarCadastrosPorEquipe()
              this.setarPercentualEquipe()
            }
          }

          // ACS
          if (this.enableSelect == 3) {
            let equipe = this.$store.state.equipesV2.find((el) => {
              return el.ine_esf_eap == this.$store.state.nu_ine
            })
            if (equipe) {
              this.equipe = {
                ine_esf_eap: equipe.ine_esf_eap,
                no_equipe: equipe.no_esf_eap,
              }
              this.setarPercentualEquipe()
            }
            this.micro_area = this.$store.state.micro_area
            this.buscarCadastrosMicroArea()
            this.setarPercentualMicroArea()
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area,
        this.ultimaAtualizacaoSincronizadorC
      )
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style></style>
